import { Component } from '@angular/core';

@Component({
  selector: 'app-page-maintenance',
  templateUrl: './page-maintenance.component.html',
  standalone: false,
})
export class PageMaintenanceComponent {
}
